var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isAdmin || _vm.hasAllResourceAccess
    ? _c("MarketplaceAdminCard", {
        attrs: {
          marketplaceUser: _vm.marketplaceUser,
          company: _vm.company,
          currentUser: _vm.currentUser,
          nameBlockMinHeight: _vm.nameBlockMinHeightValue,
          skillsBlockMinHeight: _vm.skillsBlockMinHeightValue,
        },
        on: {
          "update:nameBlockMinHeight": function ($event) {
            _vm.nameBlockMinHeightValue = $event
          },
          "update:name-block-min-height": function ($event) {
            _vm.nameBlockMinHeightValue = $event
          },
          "update:skillsBlockMinHeight": function ($event) {
            _vm.skillsBlockMinHeightValue = $event
          },
          "update:skills-block-min-height": function ($event) {
            _vm.skillsBlockMinHeightValue = $event
          },
          cardDataUpdated: function ($event) {
            return _vm.$emit("cardDataUpdated")
          },
        },
      })
    : _c("MarketplaceManagerCard", {
        attrs: {
          marketplaceUser: _vm.marketplaceUser,
          company: _vm.company,
          currentUser: _vm.currentUser,
          hasAllResourceAccess: _vm.hasAllResourceAccess,
          nameBlockMinHeight: _vm.nameBlockMinHeightValue,
          skillsBlockMinHeight: _vm.skillsBlockMinHeightValue,
        },
        on: {
          "update:nameBlockMinHeight": function ($event) {
            _vm.nameBlockMinHeightValue = $event
          },
          "update:name-block-min-height": function ($event) {
            _vm.nameBlockMinHeightValue = $event
          },
          "update:skillsBlockMinHeight": function ($event) {
            _vm.skillsBlockMinHeightValue = $event
          },
          "update:skills-block-min-height": function ($event) {
            _vm.skillsBlockMinHeightValue = $event
          },
          cardDataUpdated: function ($event) {
            return _vm.$emit("cardDataUpdated")
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }